export const INTERNAL_SAMPLER = 1;
export const SOILVIEW_SAMPLER = 2;
export const OTHER_SAMPLER = 3;
export const ROGO_SAMPLER = 4;
export const AWAITING_APPROVAL = 1;
export const APPROVED = 2;
export const SUBMITTED = 3;
export const COMPLETE = 4;
export const CANCELLED = 5;
